import React from "react";
import moment from "moment";
import * as Styles from "./styles";
import { Spacer } from "../../spacer";
import { Text } from "../../text";

export const NewsContent = ({ data }) => {
  return (
    <Styles.Wrapper>
      <Text>By: {data.authors[0].name}</Text>
      <Spacer height={1} width={3} />
      <Text>{moment(data.publishedOn).format("DD MM YYYY")}</Text>
      <Spacer height={1} width={3} />
      <Text>{data.fields.readingTime} read</Text>
    </Styles.Wrapper>
  );
};
